<div
  class="confirm-delete-playlist text-xl font-bold text-black"
  [innerHTML]="
    'MODAL.PROGRAM_DELETE_PLAYLIST.CONFIRM_NAME'
      | translate: { name: playlist.playlistName }
  "
></div>
<div class="hint text-base text-gray-darkest mt-2" translate>
  MODAL.PROGRAM_DELETE_PLAYLIST.CONFIRM_HINT
</div>
<rk-footer-actions [inline]="true" (submitted)="submit()"></rk-footer-actions>
